// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__15_oR","content":"styles_content__1NOhl","selectAll":"styles_selectAll__2IKV7"};